import { render, staticRenderFns } from "./Binding.vue?vue&type=template&id=636b18b5&scoped=true"
import script from "./Binding.vue?vue&type=script&lang=js"
export * from "./Binding.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "636b18b5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('636b18b5')) {
      api.createRecord('636b18b5', component.options)
    } else {
      api.reload('636b18b5', component.options)
    }
    module.hot.accept("./Binding.vue?vue&type=template&id=636b18b5&scoped=true", function () {
      api.rerender('636b18b5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/account/settings/Binding.vue"
export default component.exports